module.exports = __webpack_public_path__ + "static/media/bg_minigame_fish_sky.d7086e2d.png";